import React from "react";

interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: string;
  alt: string;
  iconSize?: number;
  children?: React.ReactNode;
}

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(({
  icon,
  alt,
  iconSize = 18,
  className = "",
  children,
  ...props
}, ref) => {
  return (
    <button
      ref={ref}
      type="button"
      className={`ob-notification-button ${className}`}
      {...props}
    >
      <img src={icon} alt={alt} width={iconSize} height={iconSize} />
      {children}
    </button>
  );
});

IconButton.displayName = "IconButton";
